import { cn } from '@creator/ui/utils/ui';
import { memo } from 'react';
import type { FC } from 'react';
import CommentList from '../CommentList/CommentList';

export interface RepliesProps {
    className?: string;
    tokenName: string;
    parentCommentId: string;
    postId: string;
}

const Replies: FC<RepliesProps> = props => {
    const { className = '', parentCommentId, tokenName, postId } = props;
    return <CommentList postId={postId} className={cn('space-y-2', className)} commentClassName="py-0" tokenName={tokenName} parentCommentId={parentCommentId} type="comment" />;
};

export default memo(Replies);
